import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./TrainingGroup.css";

function TrainingGroup({ id, name, name_english, language }) {
  const { t } = useTranslation();

  return (
    <Row className="training-group align-items-center">
      {language === "es" ? (
        <Col lg={11} className="training-group-header">
          <h5>{name}</h5>
        </Col>
      ) : (
        <Col lg={11} className="training-group-header">
          <h5>{name_english}</h5>
        </Col>
      )}
      <Col lg={1} className="training-group-content">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              as={Link}
              to={`/trainings/training-groups/edit/${id}`}
            >
              <FontAwesomeIcon icon={faEdit} />{" "}
              {t("Capacitaciones.Capacitacion.Editar")}
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to={`/trainings/training-groups/delete/${id}`}
            >
              <FontAwesomeIcon icon={faTrash} />{" "}
              {t("Capacitaciones.Capacitacion.Eliminar")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}

export default TrainingGroup;
